<script>
  import Account from '../../class/Account/Account'

  export default {
    name: "Login",
    data() {
      return {
        account: Account,
      }
    },
    computed: {
      title() {
        return '';
      }
    },
  }
</script>
<template>
  <div class="main">
    <h1><span>{{title}}</span></h1>
    <div class="wrap">
      <div class="main__box">{{$account.auth}}</div>
    </div>
  </div>
</template>